/* global axios */
import ApiClient from '../ApiClient';

class CaptainInsightsAPI extends ApiClient {
  constructor() {
    super('captain/insights', { accountScoped: true });
  }

  get({ page = 1, status, insightType, conversationId, excludeType } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        status,
        insight_type: insightType,
        conversation_id: conversationId,
        exclude_type: excludeType,
      },
    });
  }

  markRead(id) {
    return axios.patch(`${this.url}/${id}/mark_read`);
  }

  dismiss(id) {
    return axios.patch(`${this.url}/${id}/dismiss`);
  }

  generate(conversationId, outputs) {
    return axios.post(`${this.url}/generate`, {
      conversation_id: conversationId,
      outputs,
    });
  }
}

export default new CaptainInsightsAPI();
